'use strict';

// This function is used to initialize content-assets by checking for the existence
// of any functions attached to the window.contentAssetInitFunctions array.  Upon storefront
// initialization, this array is iterated over and all functions found within are
// individually executed in a FIFO order.
//
// NOTE: window.contentAssetInitFunctions is initialized in htmlhead.isml
//
// Content asset functions should be defined using this array following the example outlined below.
//
// // Add this initialization function to the init-array
// window.contentAssetInitFunctions.push(function() {
//    $('.plp-02-01-01-rotate').slick({
//        dots: false,
//        infinite: true,
//        speed: 300,
//        arrows: false,
//        slidesToShow: 1,
//        slidesToScroll: 1
//    });
//    $('.slick-prev-01-02-01').click(function() {
//        $('.plp-02-01-01-rotate').slick('slickPrev');
//    });
//
//    $('.slick-next-01-02-01').click(function() {
//        $('.plp-02-01-01-rotate').slick('slickNext');
//    });
// };
//
var contentAssetHelper = {

    // Use this function to execute the content-asset initialization functions that have been queued
    // for processing; this should be invoked on page-initialization events (ex. page loads for the first
    // time) and post-ajax requests (ex. after ajax content is loaded in the browser)
    initContentAssets: function () {

        // Has the contentAssetInit array been defined, and does it contain functions to execute?
        if (window.hasOwnProperty('contentAssetInitFunctions') && window.contentAssetInitFunctions.length > 0) {
            window.contentAssetInitFunctions.forEach(function (item) { item(); });
        }

    },

    // Use this function to clear the contents of the content-asset initialization functions array; this should
    // be invoked prior to any ajax-requests being processed (so that we don't build up an on-going queue
    // of function duplicates if we continue to load the same content assets via an ajax request)
    clearInitFunctions: function () {

        // Clear the contents of the content-asset initialization array
        if (window.hasOwnProperty('contentAssetInitFunctions')) { window.contentAssetInitFunctions = []; }

    }

}

module.exports = contentAssetHelper;
